import campaignSettingService from '../../services/api/campaignSetting';
import {
  CAMPAIGN_SETTING_LOAD_ACTION, CAMPAIGN_SETTING_UPDATE_ACTION
 } from '../action-types';

import { CAMPAIGN_SETTING_LOAD_MUTATION, CAMPAIGN_SETTING_CHANGE_FLOOR_MUTATION, CAMPAIGN_SETTING_CHANGE_CEILING_MUTATION, CAMPAIGN_SETTING_CHANGE_SUPPRESSAGENTBIDDING_MUTATION, CAMPAIGN_SETTING_CHANGE_BUYERTYPE_MUTATION
 } from '../mutation-types';

export const state = {
  campaignSetting: {
    campaignId: 0,
    bidFloor: 0,
    bidCeiling: 0,
    suppressAgentBidding: true,
    campaignBuyerType: 0  // Default to Auto (Story 156631)
  },
  oldCampaignSetting: {
    campaignId: 0,
    bidFloor: 0,
    bidCeiling: 0,
    suppressAgentBidding: true,
    campaignBuyerType: 0  // Default to Auto (Story 156631)
  }
};

export const actions = {
  async [CAMPAIGN_SETTING_LOAD_ACTION]({ commit }, campaignId) {
    if (!campaignId) {
      const defaultCampaignSetting = {
        campaignId: 0,
        bidFloor: 0,
        bidCeiling: 0,
        suppressAgentBidding: true,
        campaignBuyerType: 0  // Default to Auto (Story 156631)
      };
      commit(CAMPAIGN_SETTING_LOAD_MUTATION, defaultCampaignSetting);
      return;
    }
    const response = await campaignSettingService.getCampaignSetting(campaignId);
    const data = response.data ? { ...response.data } : {};
    // Ensure campaignBuyerType defaults to 0 (Auto) if not set
    if (data.campaignBuyerType == null) {
      data.campaignBuyerType = 0;
    }
    commit(CAMPAIGN_SETTING_LOAD_MUTATION, data);
    return response;
  },
  async [CAMPAIGN_SETTING_UPDATE_ACTION]({ state }) {
    if (!state.campaignSetting.bidFloor) {
      state.campaignSetting.bidFloor = 1;
    }
    if (!state.campaignSetting.bidCeiling) {
      state.campaignSetting.bidCeiling = 100;
    }
    const response = await campaignSettingService.updateCampaignSetting(state.campaignSetting);
    return response;
  },
}

export const mutations = {
  [CAMPAIGN_SETTING_LOAD_MUTATION](state, campaignSetting) {
    state.campaignSetting = campaignSetting;
    // Store a deep copy for audit comparison
    state.oldCampaignSetting = JSON.parse(JSON.stringify(campaignSetting));
  },
  [CAMPAIGN_SETTING_CHANGE_FLOOR_MUTATION](state, floor) {
    state.campaignSetting.bidFloor = floor;
  },
  [CAMPAIGN_SETTING_CHANGE_CEILING_MUTATION](state, ceiling) {
    state.campaignSetting.bidCeiling = ceiling;
  },
  [CAMPAIGN_SETTING_CHANGE_SUPPRESSAGENTBIDDING_MUTATION](state, value) {
    state.campaignSetting.suppressAgentBidding = value;
  },
  [CAMPAIGN_SETTING_CHANGE_BUYERTYPE_MUTATION](state, value) {
    state.campaignSetting.campaignBuyerType = value;
  }
}
